import { faker } from '@faker-js/faker';
import { Factory } from 'miragejs';

export default Factory.extend({
  screenname() {
    return faker.name.fullName();
  },

  name() {
    return this.screenname;
  },

  mmcIdSeries() {
    return faker.random.numeric(5);
  },

  themeType() {
    const themeTypeOptions = ['contributor', 'serie', 'project'];
    const randomIndex = Math.floor(Math.random() * themeTypeOptions.length);

    return themeTypeOptions[randomIndex];
  },

  cmsLanguageId() {
    return String(
      faker.datatype.number({
        min: 1,
        max: 2,
      }),
    );
  },

  cmsState() {
    return faker.datatype.number({
      min: 1,
      max: 3,
    });
  },

  cmsModified() {
    return faker.date.past();
  },

  afterCreate(artist, server) {
    server.createList('newsletter-target', 10);
  },
});
